import { ContentTag, DataItem, provideComponent, useData } from "scrivito"

import { DataErrorEditorNote } from "widgets/scrivito-data/DataErrorEditorNote"
import { EditorNote } from "widgets/scrivito-data/EditorNote"
import { Loading } from "widgets/scrivito-data/Loading"

import { DataWidget } from "./DataWidgetClass"

provideComponent(
  DataWidget,
  ({ widget }) => {
    const dataScope = useData()
    let dataError: unknown

    try {
      if (dataScope.isEmpty()) return <EditorNote>Data is empty.</EditorNote>
    } catch (error) {
      dataError = error
    }

    let dataItems: DataItem[]
    try {
      dataItems = dataScope.take()
    } catch (error) {
      dataItems = []
      dataError = error
    }

    if (dataError) return <DataErrorEditorNote error={dataError} />

    const items = widget.get("reverse") ? [...dataItems].reverse() : dataItems

    return (
      <>
        {items.map(dataItem => (
          <ContentTag
            content={widget}
            attribute="content"
            className="col"
            dataContext={dataItem}
            key={dataItem.id()}
          />
        ))}
      </>
    )
  },
  { loading: Loading }
)
